// extracted by mini-css-extract-plugin
export default {"productCarousel":"F0-z"};